module.exports = __webpack_public_path__ + "img/onboarding_web_2.52817d38.png";